import { Component, Input, OnInit,  QueryList, ViewChild, ViewChildren, HostListener  } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { NavParams, Platform, ToastController, IonSelect } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { BoydRewardsService } from 'src/app/services/boyd-rewards/boyd-rewards.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { NAME_PATTERN, PASSWORD_PATTERN } from 'src/app/services/customFormValidators';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { birthdayValidator } from 'src/app/services/customFormValidators';
import { isUndefined } from 'src/app/services/codeUtils';
import { CustomerModel } from 'src/app/models/customer-model';
import { ProgressingComponent } from 'src/app/components/progressing/progressing.component';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
@Component({
  selector: 'app-boyd-rewards-connect',
  templateUrl: './boyd-rewards-connect.component.html',
  styleUrls: ['./boyd-rewards-connect.component.scss'],
})
export class BoydRewardsConnectComponent implements OnInit {
  public boydNumber: AbstractControl;
  public lastName: AbstractControl;
  public dob: AbstractControl;
  public infoForm: FormGroup;
  public error = null;
  public csrf: string = '';
  public boydRewardsURL: string;
  public today: string;
  public maxDate: string;
  public minDate: string;
  public legalAge: number;
  connectBoydCardPath: boolean;
  public buttonDisabled: boolean = false;
  public dateOfBirthGroup: AbstractControl;
  public dateOfBirthYear: AbstractControl;
  public dateOfBirthDay: AbstractControl;
  public dateOfBirthMonth: AbstractControl;
  nextBtnText: string;
  callBackFn;
  isCustomerHasEmail: boolean = false;
  customer: CustomerModel;
  fetchEmailFromResponseForSignup: any;
  public thirdPartyAppsExternalID: boolean = false;
  enabledBoydApplyCard: boolean;
  @ViewChild(ProgressingComponent) progressingUI!: ProgressingComponent;
  @ViewChildren(IonSelect) ionSelect: QueryList<IonSelect>;

  constructor(private successMessageService: SuccessMessageService,
    private boydRewardsService: BoydRewardsService,
    private utils: UtilsService,
    private navigator: Navigator,
    private config: ConfigService,
    private authenticationService: AuthenticationService,
    private toastController: ToastController,
    private navParams: NavParams,
    private userSessionService: UserSessionService,
    private platform: Platform,
    private appLinks: AppLinksService
  ) {
    this.successMessageService.clearMessage();
  }

  ngOnInit() {

    this.userSessionService.getCustomer().subscribe(
      (customer) => {
        if (customer) {
          this.customer = customer;
          this.isCustomerHasEmail = !isUndefined(customer.email);
        } else {
          this.isCustomerHasEmail = false;
          this.thirdPartyAppsExternalID = false;
        }
      }, (err) => {
        console.error("getCustomer", err);
        this.isCustomerHasEmail = false;
        this.thirdPartyAppsExternalID = false;
      }
    );

    this.checkThirdPartyExternalIDs();

    this.enabledBoydApplyCard = this.config.getConfig().FEATURE_ENABLE_BOYD_APPLY_CARD ? (this.config.getConfig().FEATURE_ENABLE_BOYD_APPLY_CARD === '1' ? true : false) : true;

    this.connectBoydCardPath = this.navParams.data.connectBoydCardPath;
    this.callBackFn = this.navParams.get('callBackFn');
    this.nextBtnText = "Next";
    this.legalAge = this.config.getConfig().FEATURE_LEGAL_AGE || 21;
    this.maxDate = new Date().toJSON().split('T')[0];
    this.boydRewardsURL = this.config.getConfig()["FEATURE_BOYD_REWARDS_URL"] || "https://rewards.boydgaming.com";
    this.infoForm = new FormGroup({
      boydNumber: new FormControl('', [Validators.required, Validators.maxLength(11), this.BoydCardNumberValidator()]),
      lastName: new FormControl('', [Validators.required, Validators.pattern(NAME_PATTERN)]),
      // dob: new FormControl('',Validators.required),
      dateOfBirthGroup: new FormGroup(
        {
          dateOfBirthYear: new FormControl('', [Validators.required]),
          dateOfBirthDay: new FormControl('', [Validators.required]),
          dateOfBirthMonth: new FormControl('', [Validators.required]),
          hiddenLegalAge: new FormControl(this.legalAge)
        },
        birthdayValidator
      ),
    }
    );
    this.boydNumber = this.infoForm.get('boydNumber');
    this.lastName = this.infoForm.get('lastName');
    // this.dob = this.infoForm.get('dob');
    this.dateOfBirthGroup = this.infoForm.get('dateOfBirthGroup');
    this.dateOfBirthYear = this.dateOfBirthGroup.get('dateOfBirthYear');
    this.dateOfBirthDay = this.dateOfBirthGroup.get('dateOfBirthDay');
    this.dateOfBirthMonth = this.dateOfBirthGroup.get('dateOfBirthMonth');

    this.today = new Date().toJSON().split('T')[0];


    this.authenticationService.getCsrfToken().subscribe(
      (response) => {
        if (!isUndefined(response.payload) && !isUndefined(response.payload.token)) {
          this.csrf = response.payload.token;
        }
      }
    );
    this.changeSelectInterface();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event:Event) {
    this.changeSelectInterface();
  }

  changeSelectInterface() {
    setTimeout(() => {
      this.ionSelect.forEach((ionSelect: IonSelect) => {
        if(ionSelect){
          ionSelect.interface = this.platform.is("ios") ?  "alert" : "popover";
        }
      });
    }, 1000);
  }

  BoydCardNumberValidator(): ValidatorFn {
    return (control) => {
      const value = control.value;
      if (value) {
        if (/^[A-Za-z0-9]{4,11}$/.test(value)) {
          return null; // valid boyd card number
        } else {
          return { invalidInput: true }; // Invalid input
        }
      }
      return null;
    };
  }

  get months() {

    let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    // if(this.platform.is("capacitor")){
    //   months=['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
    // }
    if (this.dateOfBirthYear.value == this.years[0]) {
      let extra = 11 - new Date().getMonth();
      for (extra; extra > 0; extra--) {
        months.pop();
        if (this.dateOfBirthMonth.value == months.length + 1) this.dateOfBirthMonth.setValue(months.length)
      }
    }
    return months;
  }

  get days() {
    let days = Array.apply(null, { length: 31 }).map(Number.call, Number)
    let displayDays = days.map(val => val + 1).map(val => (val < 10) ? "0" + val.toString() : val.toString());
    if (
      this.dateOfBirthYear.value == this.years[0] &&
      this.dateOfBirthMonth.value - 1 == this.months.indexOf(this.months[this.months.length - 1])
    ) {
      let extra = 31 - new Date().getDate();
      for (extra; extra > 0; extra--) {
        displayDays.pop();
        if (this.dateOfBirthDay.value == displayDays.length + 1) this.dateOfBirthDay.setValue(displayDays[displayDays.length - 1]);
      }
    }
    return displayDays;
  }

  get years() {
    let years = [];
    var min = new Date().getFullYear() - 100,
      max = new Date().getFullYear() - this.legalAge;
    for (var i = max; i >= min; i--) {
      years.push(i)
    }
    return years;
  }

  generateCsrfToken() {
    this.authenticationService.getCsrfToken().subscribe(
      (response) => {
        if (!isUndefined(response.payload) && !isUndefined(response.payload.token)) {
          this.csrf = response.payload.token;
        }
      }
    );
  }


  onBack = () => {
    if (!!this.navParams.get("navigateBackPage")) {
      let navigateBackPage = this.navParams.get("navigateBackPage");
      if (navigateBackPage == "default") {
        this.navigator.dismissAll();
      } else {
        this.navigator.navigateTo(navigateBackPage);
      }
    } else {
      this.navigator.back();
    }
  };


  onSubmit() {
    this.successMessageService.clearMessage();
    this.buttonDisabled = true;
    this.error = null;
    if (this.nextBtnText === 'OK') {
      //this.navigator.toLobby();
      if (!!this.callBackFn) {
        this.navigator.dismiss();
      } else {
        this.navigator.toLobby();
      }
    } else {
      let month =
        ~~this.infoForm.value.dateOfBirthGroup.dateOfBirthMonth < 10
          ? "0" + this.infoForm.value.dateOfBirthGroup.dateOfBirthMonth
          : this.infoForm.value.dateOfBirthGroup.dateOfBirthMonth;

      let dob = new Date(
        this.infoForm.value.dateOfBirthGroup.dateOfBirthYear +
        "-" +
        month +
        "-" +
        this.infoForm.value.dateOfBirthGroup.dateOfBirthDay
      );

      let customObj: any;
      //User is already has email address/account with system and wants to connect the card
      if (this.isCustomerHasEmail) {
        customObj = {
          clientapp: this.config.getClientApp(),
          csrf: this.csrf,
          reward_number: this.boydNumber.value.trim(),
          lastName: this.lastName.value,
          birthDate: dob.toISOString().split("T")[0],
          customer_id: this.customer.customerId,
          session_token: this.userSessionService.sessionToken,
          certOver18: true,
        }
      } //Also added check for 3rd part login with externalID check
      else if (this.thirdPartyAppsExternalID) {
        customObj = {
          clientapp: this.config.getClientApp(),
          csrf: this.csrf,
          reward_number: this.boydNumber.value.trim(),
          lastName: this.lastName.value,
          birthDate: dob.toISOString().split("T")[0],
          customer_id: this.customer.customerId,
          session_token: this.userSessionService.sessionToken,
          certOver18: true,
        }
      }else {
        //User is trying to connect boyd reward but user is either guest account or visiting the site first time
        customObj = {
          clientapp: this.config.getClientApp(),
          csrf: this.csrf,
          reward_number: this.boydNumber.value.trim(),
          lastName: this.lastName.value,
          birthDate: dob.toISOString().split("T")[0],
          signup: true,
          certOver18: true,
        }
      }
      const apiCall$ = this.boydRewardsService.callExternalConnect(customObj);
      this.progressingUI.listenObservable(apiCall$);
      apiCall$.subscribe(
        (response: any) => {
          if (response && !!response.result) {
            this.buttonDisabled = false;
            //User is already has email address/account with system and wants to connect the card
            if (this.isCustomerHasEmail) {
              if (response.payload.sessionToken) {
                this.userSessionService.setSessionToken(response.payload.sessionToken);
              }
              this.boydRewardsService.connectBoydCardToStardust();
              this.userSessionService.refreshCustomer();
              this.navigator.navigateTo("AccountCreatedConfirmationComponent", { customModalClass: 'crown-modal',multipleModals: true }, { boydRewardConnectFlag: true });
            } else if (this.thirdPartyAppsExternalID) {
              //Also added check for 3rd part login with externalID check
              if (response.payload.sessionToken) {
                this.userSessionService.setSessionToken(response.payload.sessionToken);
              }
              this.boydRewardsService.connectBoydCardToStardust();
              this.userSessionService.refreshCustomer();
              this.navigator.navigateTo("AccountCreatedConfirmationComponent", { customModalClass: 'crown-modal',multipleModals: true }, { boydRewardConnectFlag: true });
            } else {
              //User is trying to connect boyd reward but user is either guest account or visiting the site first time
              //console.log(response.payload)
              if (!isUndefined(response.payload.email)) {
                this.fetchEmailFromResponseForSignup = response.payload.email;
                this.navigator.dismissAll();
                this.navigator.navigateTo("SignupStepOneComponent", { customModalClass: 'crown-modal', multipleModals: true }, { connectBoydCardPath: true, fetchEmailFromResponseForSignup: this.fetchEmailFromResponseForSignup, boydCardCustomerDataObj: customObj });
              } else {
                this.navigator.dismissAll();
                this.navigator.navigateTo("SignupStepOneComponent", { customModalClass: 'crown-modal',multipleModals: true }, { connectBoydCardPath: true, fetchEmailFromResponseForSignup: this.fetchEmailFromResponseForSignup, boydCardCustomerDataObj: customObj });
              }
            }
          } else {
            if (!!this.callBackFn) {
              this.navigator.dismiss();
              this.callBackFn();
            }
          }
        },
        (error) => {
          this.generateCsrfToken();
          // window.open(this.boydRewardsURL + "/get-connected",'_system');
          this.error = error;
          this.buttonDisabled = false;
          switch (error.getErrorCode().toUpperCase()) {
            case 'CUSTOMER_NOT_FOUND':
              error.setErrorMessage('Customer cannot be found');
              break;
            case 'CARD_ALREADY_EXISTS':
              error.setErrorMessage('Rewards Card already exists');
              break;
            case 'CUSTOMER_EXCLUDED_BY_AUTHORITY':
              error.setErrorMessage("Unfortunately, there is an error - you can’t play on this site.");
              break;
            default:
              error.setErrorMessage('Oops! We cannot confirm your account information');
              break;
          }
        }
      );
    }

  }
  closeModal = () => {
    if (!!this.callBackFn) {
      this.navigator.dismiss();
      this.callBackFn();
    }
    else {
      this.navigator.toLobby();
    }
  }

  redirectBasedOnUserData() {
    if (this.isCustomerHasEmail) {
      return this.navigator.navigateTo("ApplyBoydRewardsStepTwoComponent", { customModalClass: 'crown-modal' });
    } else {
      return this.navigator.navigateTo("ApplyBoydRewardsStepOneComponent", { customModalClass: 'crown-modal' });
    }
  }

  public goToBoydRewards() {
    const boydRewardsLink = this.config.getConfig()?.BOYD_REWARDS_WEBSITE ?? 'https://rewards.boydgaming.com/';
    return this.appLinks.openExternalPage(boydRewardsLink);
  }

  checkThirdPartyExternalIDs(){
		if(localStorage.getItem('userSession.sessionToken') !== null){
			this.authenticationService.callGetAccount().subscribe(res => {
				if ('external_associations' in res.payload) {
				  const extAssociations: any[] = res.payload.external_associations;
				  for (const e in extAssociations) {
					if (extAssociations[e].external_system === '3' || extAssociations[e].external_system === '14' || extAssociations[e].external_system === '15') {
						this.thirdPartyAppsExternalID = true;
					  break;
					}
				  }
				} else {
					this.thirdPartyAppsExternalID = false;
				}
			  }, (err) => {
				this.thirdPartyAppsExternalID = false;
			  });
		} else {
			this.thirdPartyAppsExternalID = false;
		}
	}
}
